import router from '@/router';

export const useRouter = () => router;
